import { AssemblyPaymentStatusesModel } from './models/assembly-payment.statuses';

export const ASSEMBLY_PAYMENT_STATUSES : AssemblyPaymentStatusesModel = {
  paired: 'PairedConnected'
};
